var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-icon", { attrs: { size: _vm.size } }, [
    _vm._v("\n  " + _vm._s(_vm.getCauseIcon(_vm.cause)) + "\n"),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }